
// export const logout = ( state ) => {
// }

export const setUnits = (state, units) => {
    state.units = units
}

export const setUnitsSelectable = (state, units) => {
    state.unitsSelectable = units
}

export const setUnitsPaginated = (state, unitsPaginatedData) => {
    state.unitsPaginatedData = unitsPaginatedData
}

export const setUnitDetail = (state, unit) => {
    state.unit = unit
}

export const saveNewUnits = (state, unit) => {
    state.units.unshift(unit)
    state.createdData = unit;
}

export const saveUpdatedUnit = (state, unit) => {
    state.units.unshift(unit)
    state.updatedData = unit;
}

export const setDeleteUnit = (state, unit) => {
    
    state.unitsPaginatedData.data.filter(x => x.id !== unit.id);
    state.deletedData = unit
}

export const setUnitIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setUnitIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setUnitIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setUnitIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}
